const cache = { cache: 'force-cache' }
const START_SIZE = 32

export const getScaledSources = (url, width, height) => {
  let original = { ...cache, width, height, uri: url }
  let results = [original]

  let unit =
    width > height
      ? { width: 1, height: height / width }
      : { width: width / height, height: 1 }

  for (let size = START_SIZE; unit.width * size < width; size = size * 1.5) {
    let width = Math.round(size * unit.width)
    let height = Math.round(size * unit.height)

    results.push({
      ...cache,
      width,
      height,
      uri: `${url}?w=${width}`,
    })
  }

  return results
}
